import React, { useState, useRef, useEffect } from "react";
import "../css/MissionHowItWorks.css";
import DemoVideo from "../assets/OUR MISSION.mp4";
import InvestIcon from "../assets/Invest the way you want.gif";
import TLHIcon from "../assets/Automated Tax Loss Harvestin.gif";
import MaxReturns from "../assets/Maximize After-Tax Returns.gif";
import { useNavigate } from "react-router-dom";
import * as authApi from '../api/auth';

function MissionHowItWorks( { onLogin } ) {
const navigate = useNavigate();
const [isVideoPlaying, setIsVideoPlaying] = useState(false);
const videoRef = useRef(null);

const handleDemoLogin = async () => {
  try {
    await authApi.login("demo", "demo");
    const sessionData = await authApi.me();
    const username = "demo";
    localStorage.setItem("username", username);
    if (onLogin) onLogin(username);
    navigate("/tax-insights");
  } catch (error) {
    alert("Demo login failed. Please try again.");
  }
};

const handleVideoPlay = () => {
  if (videoRef.current) {
    // Enable audio
    videoRef.current.muted = false;
    // Request fullscreen
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    } else if (videoRef.current.webkitRequestFullscreen) {
      videoRef.current.webkitRequestFullscreen();
    } else if (videoRef.current.msRequestFullscreen) {
      videoRef.current.msRequestFullscreen();
    }
    // Start playing
    videoRef.current.play();
    setIsVideoPlaying(true);
  }
};

const handleVideoStop = () => {
  if (videoRef.current) {
    videoRef.current.pause();
    videoRef.current.currentTime = 0; // Reset to beginning
    setIsVideoPlaying(false);
  }
};

  const steps = [
    {
      title: "Invest the way you want",
      description:
        "No forced ETF baskets, no hidden agendas. Unlike robo-advisors, we don't box you in",
      icon: <img src={InvestIcon} />,
    },
    {
      title: "Effortless Tax Loss Harvesting (TLH)",
      description:
        "Effortlessly reduce your tax bill with our tax loss harvesting platform. Capture strategic losses while keeping control of your own investment strategy.",
      icon: <img src={TLHIcon} />,
    },
    {
      title: "Maximize After-Tax Returns",
      description:
        "Keep more of your gains with tax-smart investing—minimizing taxes for maximum returns.",
      icon: <img className="max-returns-scale" src={MaxReturns} />,
    },
  ];

  return (
    <section className="mission-how-it-works">
      <div className="content-wrapper">
        <div className="mission-content-container">
          <h2 className="mission-heading">MAKE YOUR MONEY HUSTLE</h2>
          <h3 className="mission-sub-heading">so you don't have to...</h3>
        </div>
        <div className="mission-content-container">
          <div className="video-container">
            
            <video 
              ref={videoRef}
              className="demogiftrial" 
              muted 
              loop 
              playsInline
              onPlay={() => {
                setIsVideoPlaying(true);
              }}
              onPause={() => {
                setIsVideoPlaying(false);
              }}
            >
              <source src={DemoVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            
            {/* Video Overlay Button */}
            {!isVideoPlaying && (
              <div className="video-overlay">
                <button 
                  className="video-play-button"
                  onClick={handleVideoPlay}
                >
                  <span className="play-icon">▶</span>
                  Watch our demo
                </button>
              </div>
            )}

            {/* Close Button - appears when video is playing */}
            {isVideoPlaying && (
              <button 
                className="video-close-button"
                onClick={handleVideoStop}
                aria-label="Stop video"
              >
                ✕
              </button>
            )}
          </div>
          
          <br/>
          <br/>

          {/* Add CTA Buttons Here */}
          <div className="cta-container">
            <button
              className="mission-cta-button"
              onClick={handleDemoLogin}
            >
              Try Demo Mode
            </button>

            {/* <button
              className="cta-secondary-button"
              onClick={() => {
                window.location.href = "/about"; // Replace with your learn TLH URL
              }}
            >
              ProfiTree's Mission
            </button> */}
          </div>
          <div className="steps-grid">
            {steps.map((step, index) => (
              <div className="step-card" key={index}>
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionHowItWorks;
